export const ICON_SIZE_IN_PIXEL = 14;
export const TEXT_READY_STOCK_DESC_ONE = 'Ready Stocks';
export const TEXT_READY_STOCK_DESC_TWO = 'Immediate Registration';
export const TEXT_READY_STOCK_DESC_THREE = '100% Delivery';
export const TEXT_READY_STOCK_DESC_FOUR = 'Verified Ready Stocks are vehicles that have cleared all LTA paperwork and ready to be registered immediately. This is verified by Sgcarmart with the '; // @suppress longLineCheck
export const TEXT_READY_STOCK_DESC_FIVE = ' issued by LTA.'; // @suppress longLineCheck
export const COLUMN_TITLE_SUBMODEL = 'Submodel';
export const COLUMN_TITLE_DEALER = 'Dealer';
export const COLUMN_TITLE_PRICE = 'Price';
